import accountDetails from './accountDetails/accountDetailsSlice';
import detailedHours from './detailedHours/detailedHoursSlice';

const root = {
	accountDetails,
	detailedHours
};

export default root;
